// Exakter Wortlaut der Datenschutzerklaerung (Stand: Juli 2026)
// Strings = Absaetze, Arrays = Aufzaehlungen
export const PRIVACY_UPDATED = "Stand: Juli 2026";

export const PRIVACY_SECTIONS = [
  {
    title: "1. Allgemeine Hinweise",
    blocks: [
      "Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Nachfolgend informieren wir Sie darüber, welche personenbezogenen Daten beim Besuch dieser Website, bei der Kontaktaufnahme mit uns und im Rahmen unserer Geschäftsbeziehung verarbeitet werden, zu welchen Zwecken die Verarbeitung erfolgt und welche Rechte Ihnen zustehen.",
      "Personenbezogene Daten sind alle Informationen, mit denen eine natürliche Person direkt oder indirekt identifiziert werden kann. Dazu gehören beispielsweise der Name, die Anschrift, eine Telefonnummer, eine E-Mail-Adresse, die IP-Adresse sowie projektbezogene oder geschäftliche Informationen, sofern diese einer bestimmten Person zugeordnet werden können.",
    ],
  },
  {
    title: "2. Verantwortlicher",
    blocks: [
      "Verantwortlich für die Datenverarbeitung auf dieser Website ist:",
      [
        "SBO Commerce",
        "Einzelunternehmen",
        "Inhaber: Sinan Boztepe",
        "Rosmarinweg 45",
        "86156 Augsburg",
        "Deutschland",
        "Telefon: +49 1556 7304351",
        "E-Mail: info@vision-one.io",
      ],
    ],
  },
  {
    title:
      "3. Erhebung und Verarbeitung personenbezogener Daten beim Besuch der Website",
    blocks: [
      "Beim Aufruf dieser Website werden automatisch technische Informationen verarbeitet, die Ihr Browser an den Server übermittelt.",
      "Hierzu können insbesondere gehören:",
      [
        "IP-Adresse",
        "Datum und Uhrzeit der Anfrage",
        "aufgerufene Seite oder Datei",
        "Referrer-URL",
        "verwendeter Browser",
        "verwendetes Betriebssystem",
        "Spracheinstellungen",
        "übertragene Datenmenge",
        "Zugriffsstatus beziehungsweise HTTP-Statuscode",
      ],
      "Diese Daten werden verarbeitet, um die Website technisch bereitzustellen, Inhalte korrekt auszuliefern, die Stabilität und Sicherheit der Systeme zu gewährleisten sowie technische Fehler und missbräuchliche Zugriffe erkennen zu können.",
      "Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der sicheren, stabilen und fehlerfreien Bereitstellung unserer Website.",
    ],
  },
  {
    title: "4. Hosting über Vercel",
    blocks: [
      "Diese Website wird bei einem externen Hosting-Dienstleister betrieben.",
      "Anbieter ist:",
      [
        "Vercel Inc.",
        "440 N Barranca Avenue #4133",
        "Covina, CA 91723",
        "USA",
      ],
      "Beim Besuch dieser Website können technische Zugriffsdaten, insbesondere IP-Adressen, Browserinformationen und Server-Logdaten, durch Vercel verarbeitet werden. Die Verarbeitung erfolgt zum Zweck der Bereitstellung, Absicherung und Auslieferung der Website.",
      "Soweit Vercel personenbezogene Daten in unserem Auftrag verarbeitet, erfolgt dies auf Grundlage einer Vereinbarung zur Auftragsverarbeitung gemäß Art. 28 DSGVO.",
      "Vercel setzt für den Betrieb seiner Infrastruktur weitere Dienstleister und Unterauftragsverarbeiter ein. Hierzu können insbesondere Anbieter von Cloud-Infrastruktur und Rechenzentrumsleistungen gehören.",
      "Da Vercel seinen Sitz in den USA hat und weltweit technische Infrastruktur einsetzt, kann eine Übermittlung personenbezogener Daten in Staaten außerhalb der Europäischen Union beziehungsweise des Europäischen Wirtschaftsraums stattfinden.",
      "Vercel ist nach eigenen Angaben unter dem EU-U.S. Data Privacy Framework zertifiziert. Darüber hinaus können für internationale Datenübermittlungen Standardvertragsklauseln der Europäischen Kommission und ergänzende Schutzmaßnahmen eingesetzt werden.",
      "Rechtsgrundlage für die Nutzung von Vercel ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in einer sicheren, leistungsfähigen und zuverlässigen Bereitstellung unserer Website.",
    ],
  },
  {
    title: "5. Kontaktaufnahme per Telefon oder E-Mail",
    blocks: [
      "Wenn Sie uns telefonisch oder per E-Mail kontaktieren, verarbeiten wir die von Ihnen übermittelten personenbezogenen Daten zur Bearbeitung Ihrer Anfrage.",
      "Hierzu können insbesondere gehören:",
      [
        "Name",
        "Unternehmen",
        "Telefonnummer",
        "E-Mail-Adresse",
        "Inhalt Ihrer Nachricht",
        "Informationen zu einem geplanten Website- oder Marketingprojekt",
        "Angaben zu bestehenden Websites, Domains oder technischen Systemen",
        "von Ihnen freiwillig übermittelte Dateien, Bilder oder Dokumente",
      ],
      "Die Verarbeitung erfolgt zur Kommunikation mit Ihnen, zur Bearbeitung Ihrer Anfrage sowie gegebenenfalls zur Vorbereitung oder Durchführung eines Vertrags über Webdesign-, Entwicklungs-, Hosting-, Wartungs-, Beratungs- oder Marketingleistungen.",
      "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage auf die Anbahnung oder Durchführung eines Vertrags gerichtet ist.",
      "In allen übrigen Fällen erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der sachgerechten und effizienten Bearbeitung eingehender Anfragen.",
    ],
  },
  {
    title: "6. Kontaktformular",
    blocks: [
      "Wenn Sie das Kontaktformular auf dieser Website nutzen, verarbeiten wir die von Ihnen eingegebenen Daten zur Bearbeitung Ihrer Anfrage.",
      "Über das Kontaktformular können insbesondere folgende Daten verarbeitet werden:",
      [
        "Name",
        "Unternehmen",
        "E-Mail-Adresse",
        "Telefonnummer",
        "Betreff",
        "Inhalt der Nachricht",
        "Angaben zum gewünschten Projekt oder zur gewünschten Leistung",
      ],
      "Zusätzlich können technisch erforderliche Informationen verarbeitet werden, insbesondere:",
      [
        "IP-Adresse",
        "Browsertyp",
        "Datum und Uhrzeit der Übermittlung",
        "Referrer-Adresse",
        "technische Informationen zur Formularübermittlung",
      ],
      "Die Formulardaten werden verschlüsselt an den von uns eingesetzten Formulardienst Formspark übermittelt. Formspark verarbeitet die Daten und leitet die Anfrage an die von uns hinterlegte E-Mail-Adresse weiter. Die Anfrage kann zusätzlich im Formspark-Dashboard gespeichert werden.",
      "Die Verarbeitung erfolgt zur Bearbeitung Ihrer Kontaktanfrage und gegebenenfalls zur Vorbereitung oder Durchführung eines Vertrags.",
      "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit Ihre Anfrage der Anbahnung oder Durchführung eines Vertrags dient.",
      "In den übrigen Fällen erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der zuverlässigen und effizienten Bearbeitung eingehender Anfragen.",
    ],
  },
  {
    title: "7. Formularverarbeitung über Formspark",
    blocks: [
      "Für die technische Bereitstellung, Verarbeitung und Weiterleitung von Anfragen aus unserem Kontaktformular nutzen wir Formspark.",
      "Betreiber des Dienstes ist:",
      ["Trampoline Software SRL", "Belgien", "E-Mail: support@formspark.io"],
      "Wenn Sie das Kontaktformular absenden, werden die von Ihnen eingegebenen Daten an Formspark übertragen.",
      "Hierbei können insbesondere folgende Daten verarbeitet werden:",
      [
        "Name",
        "Unternehmen",
        "E-Mail-Adresse",
        "Telefonnummer",
        "Betreff",
        "Inhalt Ihrer Nachricht",
        "IP-Adresse",
        "Browsertyp",
        "Referrer-Adresse",
        "Datum und Uhrzeit der Übermittlung",
      ],
      "Formspark verarbeitet diese Daten, um die Kontaktanfrage entgegenzunehmen, im Formspark-Dashboard bereitzustellen und per E-Mail an uns weiterzuleiten.",
      "Nach Angaben von Formspark werden die Dienste aus Belgien betrieben und übermittelte Daten in Irland gespeichert.",
      "Formspark setzt zur Erbringung seines Dienstes weitere Unterauftragsverarbeiter ein. Hierzu können insbesondere Anbieter für Cloud-Infrastruktur, E-Mail-Zustellung, Spam-Erkennung, IP-Geolokalisierung, Fehleranalyse und die technische Darstellung von E-Mail-Benachrichtigungen gehören.",
      "Soweit Formspark personenbezogene Daten in unserem Auftrag verarbeitet, erfolgt die Verarbeitung auf Grundlage einer Vereinbarung zur Auftragsverarbeitung gemäß Art. 28 DSGVO.",
      "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Kontaktaufnahme der Vorbereitung oder Durchführung eines Vertrags dient.",
      "In den übrigen Fällen erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in einer sicheren und zuverlässigen Entgegennahme und Bearbeitung von Kontaktanfragen.",
    ],
  },
  {
    title: "8. Keine Übermittlung sensibler Daten über das Kontaktformular",
    blocks: [
      "Bitte übermitteln Sie über das Kontaktformular keine besonderen Kategorien personenbezogener Daten im Sinne von Art. 9 DSGVO.",
      "Hierzu gehören insbesondere Angaben über:",
      [
        "den Gesundheitszustand",
        "medizinische Behandlungen",
        "religiöse oder weltanschauliche Überzeugungen",
        "politische Meinungen",
        "Gewerkschaftszugehörigkeit",
        "biometrische oder genetische Daten",
        "das Sexualleben oder die sexuelle Orientierung",
      ],
      "Bitte übermitteln Sie über das Kontaktformular außerdem keine Ausweisdokumente, vollständigen Bankunterlagen, Passwörter, vertraulichen Zugangsdaten, Daten von Kindern, strafrechtlichen Informationen oder sonstigen besonders sensiblen Dokumente.",
      "Sollten solche Informationen im Rahmen eines Projekts erforderlich sein, kontaktieren Sie uns bitte zunächst telefonisch oder per E-Mail. Anschließend kann ein geeigneter Übermittlungsweg abgestimmt werden.",
    ],
  },
  {
    title: "9. Verarbeitung von Kunden-, Vertrags- und Projektdaten",
    blocks: [
      "Wenn Sie uns mit einer Leistung beauftragen, verarbeiten wir die personenbezogenen Daten, die zur Vorbereitung, Durchführung und Abwicklung des Vertrags erforderlich sind.",
      "Hierzu können insbesondere gehören:",
      [
        "Name und Kontaktdaten",
        "Unternehmen und Position",
        "Geschäftsanschrift",
        "Rechnungs- und Zahlungsdaten",
        "Vertrags- und Angebotsdaten",
        "Kommunikationsinhalte",
        "Angaben zu Domains, Websites und Hostingverträgen",
        "technische Informationen zu bestehenden Systemen",
        "Projektanforderungen und Briefings",
        "Texte, Bilder, Videos, Logos und sonstige Medien",
        "Corporate-Design- und Markenunterlagen",
        "Informationen zu Produkten, Leistungen und Zielgruppen",
        "Zugangsdaten zu technischen Systemen, soweit diese für die Leistungserbringung erforderlich sind",
        "Support- und Wartungsanfragen",
      ],
      "Die Verarbeitung erfolgt insbesondere für folgende Zwecke:",
      [
        "Erstellung und Bearbeitung von Angeboten",
        "Vertragsabschluss und Vertragsdurchführung",
        "Konzeption, Gestaltung und Entwicklung von Websites",
        "technische Einrichtung und Veröffentlichung von Websites",
        "Einrichtung oder Verwaltung von Domains und Hosting",
        "Suchmaschinenoptimierung",
        "Wartung, Pflege und Aktualisierung von Websites",
        "technische Fehlerbehebung und Support",
        "Abrechnung und Zahlungsabwicklung",
        "Dokumentation der erbrachten Leistungen",
        "Kommunikation mit Kunden und Projektbeteiligten",
        "Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen",
      ],
      "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.",
      "Soweit gesetzliche Dokumentations-, Buchführungs- oder Aufbewahrungspflichten bestehen, erfolgt die Verarbeitung zusätzlich auf Grundlage von Art. 6 Abs. 1 lit. c DSGVO.",
      "Soweit die Verarbeitung zur rechtlichen Absicherung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist, erfolgt sie auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO.",
    ],
  },
  {
    title: "10. Verarbeitung von Inhalten und Daten Dritter",
    blocks: [
      "Im Rahmen eines Website- oder Marketingprojekts können Kunden uns personenbezogene Daten oder Inhalte zur Verfügung stellen, die sich auf andere Personen beziehen.",
      "Hierzu können beispielsweise gehören:",
      [
        "Namen und Kontaktdaten von Mitarbeitern oder Ansprechpartnern",
        "Teamfotos und Mitarbeiterprofile",
        "Kundenstimmen und Bewertungen",
        "Referenzprojekte",
        "Fotos oder Videos, auf denen Personen erkennbar sind",
        "Kontaktdaten von Dienstleistern und Kooperationspartnern",
        "Inhalte aus bestehenden Websites oder Unternehmensunterlagen",
        "Daten, die in rechtlichen Pflichtangaben oder Kontaktbereichen veröffentlicht werden sollen",
      ],
      "Diese Daten werden ausschließlich verarbeitet, soweit dies für die Durchführung des jeweiligen Auftrags erforderlich ist.",
      "Der Auftraggeber ist grundsätzlich dafür verantwortlich, dass die zur Verfügung gestellten Inhalte und personenbezogenen Daten rechtmäßig erhoben wurden und für das jeweilige Projekt verwendet beziehungsweise veröffentlicht werden dürfen.",
      "Rechtsgrundlage der Verarbeitung ist Art. 6 Abs. 1 lit. b DSGVO, soweit die Verarbeitung zur Durchführung des Vertrags erforderlich ist.",
      "Im Übrigen erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der ordnungsgemäßen Umsetzung des beauftragten Projekts.",
    ],
  },
  {
    title: "11. Zugangsdaten und Zugriff auf Kundensysteme",
    blocks: [
      "Für die Durchführung von Webdesign-, Hosting-, Wartungs- oder Supportleistungen kann es erforderlich sein, dass Kunden uns Zugang zu technischen Systemen gewähren.",
      "Hierzu können insbesondere gehören:",
      [
        "Domain- und DNS-Verwaltungen",
        "Hostingkonten",
        "Content-Management-Systeme",
        "Website-Baukästen",
        "E-Mail-Systeme",
        "Analyse- oder Marketingkonten",
        "Unternehmensprofile",
        "Quellcode-Repositories",
        "Datenbanken",
        "Schnittstellen und API-Zugänge",
      ],
      "Zugangsdaten werden nur verarbeitet, soweit dies für die vereinbarte Leistung erforderlich ist. Sie werden nicht ohne Berechtigung an Dritte weitergegeben.",
      "Nach Abschluss des Projekts werden nicht mehr benötigte Zugangsdaten gelöscht beziehungsweise aus den von uns verwendeten Systemen entfernt, sofern keine weitere Betreuung, Wartung oder Supportleistung vereinbart wurde und keine gesetzlichen oder rechtlichen Gründe für eine weitere Speicherung bestehen.",
      "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.",
    ],
  },
  {
    title: "12. Auftragsverarbeitung im Rahmen von Kundenprojekten",
    blocks: [
      "Im Rahmen von Hosting-, Wartungs-, Support- oder technischen Betreuungsleistungen kann es vorkommen, dass wir Zugriff auf personenbezogene Daten erhalten, für die unser Kunde datenschutzrechtlich verantwortlich ist.",
      "Dies kann beispielsweise der Fall sein, wenn wir Zugriff auf folgende Bereiche erhalten:",
      [
        "Kontaktformularanfragen einer Kundenwebsite",
        "Benutzer- oder Kundenkonten",
        "Website-Datenbanken",
        "Newsletter-Systeme",
        "Buchungs- oder Terminsysteme",
        "Analyse- oder Marketingkonten",
        "Serverprotokolle",
        "E-Mail-Postfächer",
        "technische Administrationsoberflächen",
      ],
      "Soweit wir solche personenbezogenen Daten ausschließlich nach Weisung des Kunden verarbeiten, handeln wir als Auftragsverarbeiter im Sinne von Art. 28 DSGVO.",
      "In diesen Fällen wird, soweit erforderlich, eine gesonderte Vereinbarung zur Auftragsverarbeitung abgeschlossen. Der jeweilige Kunde bleibt Verantwortlicher für die datenschutzrechtliche Zulässigkeit der Verarbeitung auf seiner Website beziehungsweise in seinen Systemen.",
    ],
  },
  {
    title: "13. Einsatz von freien Mitarbeitern und Unterauftragnehmern",
    blocks: [
      "Für die Durchführung einzelner Projekte können wir geeignete freie Mitarbeiter, Entwickler, Designer oder sonstige technische Dienstleister einsetzen.",
      "Eine Übermittlung personenbezogener Daten erfolgt nur, soweit dies für die Durchführung des jeweiligen Projekts erforderlich ist.",
      "Die eingesetzten Personen und Dienstleister werden zur Vertraulichkeit verpflichtet. Soweit sie personenbezogene Daten in unserem Auftrag verarbeiten, erfolgt dies auf Grundlage einer Vereinbarung zur Auftragsverarbeitung gemäß Art. 28 DSGVO.",
      "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, soweit der Einsatz zur Durchführung eines Vertrags erforderlich ist.",
      "Im Übrigen erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in einer fachgerechten und effizienten Durchführung unserer Leistungen.",
    ],
  },
  {
    title: "14. Rechnungsstellung, Buchhaltung und Zahlungsabwicklung",
    blocks: [
      "Zur Erstellung und Bearbeitung von Angeboten, Verträgen und Rechnungen verarbeiten wir die hierfür erforderlichen Kunden- und Zahlungsdaten.",
      "Hierzu können gehören:",
      [
        "Name",
        "Unternehmen",
        "Anschrift",
        "E-Mail-Adresse",
        "Steuernummer oder Umsatzsteuer-Identifikationsnummer",
        "Bankverbindung",
        "Rechnungsbeträge",
        "Zahlungsstatus",
        "Vertrags- und Leistungsinformationen",
      ],
      "Die Daten können im erforderlichen Umfang an Banken, Zahlungsdienstleister, Steuerberater, Buchhaltungsdienstleister oder Finanzbehörden übermittelt werden.",
      "Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO für die Vertragsabwicklung sowie Art. 6 Abs. 1 lit. c DSGVO für die Erfüllung gesetzlicher Buchführungs-, Steuer- und Aufbewahrungspflichten.",
    ],
  },
  {
    title: "15. Weitergabe personenbezogener Daten",
    blocks: [
      "Eine Weitergabe personenbezogener Daten erfolgt grundsätzlich nur, wenn:",
      [
        "dies zur Bearbeitung einer Anfrage oder zur Durchführung eines Vertrags erforderlich ist,",
        "eine gesetzliche Verpflichtung besteht,",
        "eine Einwilligung erteilt wurde,",
        "ein berechtigtes Interesse besteht und keine überwiegenden Interessen der betroffenen Person entgegenstehen oder",
        "die Weitergabe zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist.",
      ],
      "Je nach Sachverhalt können personenbezogene Daten insbesondere an folgende Empfänger übermittelt werden:",
      [
        "Hosting- und Cloudanbieter",
        "Formulardienstleister",
        "Domainregistrare",
        "E-Mail- und Kommunikationsdienstleister",
        "IT- und Supportdienstleister",
        "freie Mitarbeiter und Unterauftragnehmer",
        "Steuerberater und Buchhaltungsdienstleister",
        "Banken und Zahlungsdienstleister",
        "Rechtsanwälte",
        "Behörden oder Gerichte",
        "sonstige Projektpartner, soweit dies zur Leistungserbringung erforderlich ist",
      ],
      "Eine Weitergabe personenbezogener Daten zu fremden Werbezwecken erfolgt nicht.",
    ],
  },
  {
    title: "16. Technische Dienstleister und Auftragsverarbeitung",
    blocks: [
      "Für den Betrieb dieser Website, die technische Übermittlung von Kontaktanfragen und die Durchführung unserer Leistungen setzen wir technische Dienstleister ein.",
      "Soweit diese Dienstleister personenbezogene Daten in unserem Auftrag verarbeiten, erfolgt dies auf Grundlage einer Vereinbarung zur Auftragsverarbeitung gemäß Art. 28 DSGVO.",
      "Die Dienstleister dürfen personenbezogene Daten grundsätzlich nur nach unseren Weisungen und für die vereinbarten Zwecke verarbeiten.",
    ],
  },
  {
    title: "17. Cookies und vergleichbare Technologien",
    blocks: [
      "Diese Website verwendet nach aktuellem Stand keine nicht notwendigen Tracking-Cookies und keine zustimmungspflichtigen Analyse- oder Marketingtechnologien.",
      "Technisch notwendige Cookies, lokale Speichertechnologien oder vergleichbare Funktionen können eingesetzt werden, soweit sie für den sicheren und funktionsfähigen Betrieb der Website unbedingt erforderlich sind.",
      "Der Zugriff auf Informationen im Endgerät des Nutzers oder die Speicherung solcher Informationen erfolgt, soweit technisch unbedingt erforderlich, auf Grundlage von § 25 Abs. 2 TDDDG.",
      "Die anschließende Verarbeitung personenbezogener Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der technischen Bereitstellung, Funktionsfähigkeit und Sicherheit der Website.",
    ],
  },
  {
    title: "18. Keine Analyse- und Marketingtools",
    blocks: [
      "Auf dieser Website werden nach aktuellem Stand keine Analyse- oder Marketingdienste wie Google Analytics, Google Ads Conversion Tracking, Meta Pixel, TikTok Pixel oder vergleichbare Trackingtechnologien eingesetzt.",
      "Sollten künftig Analyse- oder Marketingdienste eingesetzt werden, wird diese Datenschutzerklärung entsprechend ergänzt.",
      "Soweit für den Einsatz solcher Dienste eine Einwilligung erforderlich ist, werden diese Dienste erst nach Erteilung einer entsprechenden Einwilligung aktiviert.",
    ],
  },
  {
    title: "19. Externe Links",
    blocks: [
      "Diese Website kann Links zu externen Websites, sozialen Netzwerken oder anderen Diensten enthalten.",
      "Wenn Sie einen externen Link anklicken, verlassen Sie unsere Website. Erst durch das aktive Anklicken des Links wird eine Verbindung zum jeweiligen externen Anbieter hergestellt.",
      "Für die Verarbeitung personenbezogener Daten auf der externen Website ist der jeweilige Anbieter verantwortlich. Bitte beachten Sie die Datenschutzhinweise des jeweiligen Anbieters.",
    ],
  },
  {
    title: "20. Speicherdauer",
    blocks: [
      "Wir speichern personenbezogene Daten nur so lange, wie dies für die jeweiligen Verarbeitungszwecke erforderlich ist oder gesetzliche Aufbewahrungspflichten bestehen.",
      "Daten aus allgemeinen Kontaktanfragen werden gelöscht, sobald die Anfrage abschließend bearbeitet wurde und keine gesetzlichen, vertraglichen oder rechtlichen Gründe für eine weitere Speicherung bestehen.",
      "Kommt ein Vertrag zustande, werden die für die Vertragsdurchführung erforderlichen Daten für die Dauer der Geschäftsbeziehung gespeichert.",
      "Projektunterlagen, Kommunikation, Angebote, Verträge und sonstige geschäftliche Dokumente können darüber hinaus gespeichert werden, soweit dies zur Dokumentation der Leistungen, zur Bearbeitung von Gewährleistungs- oder Haftungsfragen oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist.",
      "Steuerlich und handelsrechtlich relevante Unterlagen können abhängig von der Art des Dokuments gesetzlichen Aufbewahrungsfristen von sechs, acht oder zehn Jahren unterliegen.",
      "Kontaktanfragen können sowohl im Formspark-Dashboard als auch in unserem E-Mail-Postfach gespeichert werden. Einträge werden gelöscht, sobald sie nicht mehr benötigt werden und keine gesetzlichen oder rechtlichen Gründe für eine weitere Speicherung bestehen.",
      "Zugangsdaten zu Kundensystemen werden gelöscht beziehungsweise entfernt, sobald sie für die vereinbarte Leistung nicht mehr erforderlich sind, sofern keine laufende Betreuung oder Wartung vereinbart wurde.",
    ],
  },
  {
    title: "21. Datensicherheit",
    blocks: [
      "Wir treffen geeignete technische und organisatorische Maßnahmen, um personenbezogene Daten vor Verlust, Missbrauch, unbefugtem Zugriff, Veränderung oder Offenlegung zu schützen.",
      "Diese Website wird verschlüsselt übertragen, sofern Ihr Browser eine verschlüsselte Verbindung unterstützt. Eine verschlüsselte Verbindung erkennen Sie in der Regel an „https://“ in der Adresszeile Ihres Browsers.",
      "Trotz angemessener Sicherheitsmaßnahmen kann eine vollständig risikofreie Datenübertragung über das Internet nicht garantiert werden.",
    ],
  },
  {
    title: "22. Pflicht zur Bereitstellung personenbezogener Daten",
    blocks: [
      "Sie sind grundsätzlich nicht verpflichtet, uns personenbezogene Daten bereitzustellen.",
      "Ohne bestimmte Angaben kann es jedoch sein, dass wir Ihre Anfrage nicht oder nur eingeschränkt bearbeiten, kein Angebot erstellen oder einen Vertrag nicht durchführen können.",
      "Im Rahmen eines Vertrags sind diejenigen personenbezogenen Daten bereitzustellen, die für die Begründung, Durchführung und Beendigung des Vertrags erforderlich sind oder zu deren Erhebung eine gesetzliche Verpflichtung besteht.",
    ],
  },
  {
    title: "23. Keine automatisierte Entscheidungsfindung",
    blocks: [
      "Eine automatisierte Entscheidungsfindung einschließlich Profiling im Sinne von Art. 22 DSGVO findet nicht statt.",
    ],
  },
  {
    title: "24. Ihre Datenschutzrechte",
    blocks: [
      "Sie haben im Rahmen der gesetzlichen Voraussetzungen insbesondere folgende Rechte:",
      [
        "Recht auf Auskunft über Ihre gespeicherten personenbezogenen Daten gemäß Art. 15 DSGVO",
        "Recht auf Berichtigung unrichtiger oder unvollständiger Daten gemäß Art. 16 DSGVO",
        "Recht auf Löschung gemäß Art. 17 DSGVO",
        "Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO",
        "Recht auf Datenübertragbarkeit gemäß Art. 20 DSGVO",
        "Recht auf Widerspruch gegen die Verarbeitung gemäß Art. 21 DSGVO",
        "Recht auf Widerruf einer erteilten Einwilligung gemäß Art. 7 Abs. 3 DSGVO",
        "Recht auf Beschwerde bei einer Datenschutzaufsichtsbehörde gemäß Art. 77 DSGVO",
      ],
      "Zur Ausübung Ihrer Rechte können Sie sich jederzeit an uns wenden:",
      ["E-Mail: info@vision-one.io"],
    ],
  },
  {
    title: "25. Widerspruchsrecht nach Art. 21 DSGVO",
    blocks: [
      "Soweit die Verarbeitung Ihrer personenbezogenen Daten auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO erfolgt, haben Sie das Recht, aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit Widerspruch gegen die Verarbeitung einzulegen.",
      "Nach einem Widerspruch werden wir die betreffenden personenbezogenen Daten nicht mehr verarbeiten, es sei denn, wir können zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen.",
      "Eine weitere Verarbeitung kann außerdem erfolgen, wenn sie der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen dient.",
    ],
  },
  {
    title: "26. Widerruf einer Einwilligung",
    blocks: [
      "Soweit eine Datenverarbeitung auf Ihrer Einwilligung beruht, können Sie diese Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.",
      "Die Rechtmäßigkeit der Verarbeitung, die bis zum Zeitpunkt des Widerrufs auf Grundlage der Einwilligung erfolgt ist, bleibt vom Widerruf unberührt.",
    ],
  },
  {
    title: "27. Beschwerderecht bei einer Aufsichtsbehörde",
    blocks: [
      "Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die DSGVO verstößt.",
      "Für nicht öffentliche Unternehmen mit Sitz in Bayern ist insbesondere folgende Aufsichtsbehörde zuständig:",
      [
        "Bayerisches Landesamt für Datenschutzaufsicht – BayLDA",
        "Promenade 18",
        "91522 Ansbach",
        "Deutschland",
        "Telefon: +49 981 180093-0",
        "E-Mail: poststelle@lda.bayern.de",
      ],
      "Das Beschwerderecht besteht unbeschadet anderer verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.",
    ],
  },
  {
    title: "28. Änderungen dieser Datenschutzerklärung",
    blocks: [
      "Wir behalten uns vor, diese Datenschutzerklärung anzupassen, wenn sich rechtliche Anforderungen, technische Gegebenheiten, eingesetzte Dienstleister oder unsere Datenverarbeitungsprozesse ändern.",
      "Es gilt die jeweils auf dieser Website veröffentlichte Fassung.",
    ],
  },
];
